import { PublicSignupResponse as SignupResponseDto } from '@electricjs/core_entity-client';

export const signupResponse: SignupResponseDto = {
  success: true,
  organization_id: '67d26876-05a6-11ee-be56-0242ac120002',
  organization_name: 'Simple Org',
  external_organization_id: 'external-org-id',
};
